namespace HA.Core.Repository {
    import HARouter = HA.Core.Route.HARouter;

    export class Repository extends HAObject {

        /**
         *
         * @param data
         * @param entity
         */
        public cache(data: Map<any, any>, entity: any) {
            this.getCache().set(data.get("id"), entity);
        }

        /**
         *
         * @param id
         */
        protected delFromCache(id: string) {
            return this.getCache().delete(id);
        }

        public clearCache(): void {
            this.addToData("cache", toMap([]));
        }

        /**
         *
         * @param data
         * @returns {any}
         */
        protected getFromCache(data: Map<any, any>) {
            return this.getCache().get(data.get("id"));
        }

        /**
         *
         * @param data
         * @returns {boolean}
         */
        protected isCached(data: Map<any, any>): boolean {
            const id = data.get("id") ?? null;
            if (!id) return false;
            return this.getCache().has(id);
        }

        /**
         *
         * @returns {Map}
         */
        protected getCache() {
            return this.get("cache");
        }

        protected request(data: Map<any, any>): Promise<any> {
            return this.getRouter().post(data);
        }

        protected requestGet(data: Map<any, any>): Promise<any> {
            return this.getRouter().doGet(data);
        }

        protected getRouter(): HARouter {
            if (this.hasNot("router")) {
                this.addToData("router", new HA.Core.Route.HARouter());
            }
            return this.get("router");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addToData("cache", toMap([]));
        }
    }
}
